/* hc-xw-track.js - Xena first-party click tracking to GA4 (backup to Microsoft Clarity). Dex 2026-10-16.
   One delegated capture-phase listener. No MutationObserver, no DOM writes. Events:
   xw_click (every meaningful click), xw_nav_click (header/mega/drawer/footer links), xw_menu_open (header disclosure).
   Params: xw_area, xw_group, xw_label, xw_target, xw_section, xw_page_type, xw_device, xw_x_pct, xw_y_px. */
(function () {
  if (window.__xwTrack) return;
  window.__xwTrack = true;
  var BOT = /bot|crawl|spider|headless|lighthouse|pagespeed|gtmetrix|preview/i;
  if (BOT.test(navigator.userAgent || '') || navigator.webdriver && !window.__xwTrackSink) return;
  var last = { k: '', t: 0 };
  function pageType() {
    var p = location.pathname;
    if (p === '/' || p === '') return 'home';
    if (p.indexOf('/products/') > -1) return 'product';
    if (p.indexOf('/collections/') > -1) return 'collection';
    if (p.indexOf('/cart') === 0) return 'cart';
    if (p.indexOf('/pages/') > -1) return 'page';
    if (p.indexOf('/blogs/') > -1) return 'blog';
    if (p.indexOf('/search') === 0) return 'search';
    return 'other';
  }
  function txt(el) {
    var t = (el.getAttribute('aria-label') || el.innerText || el.textContent || el.getAttribute('title') || el.getAttribute('alt') || '').replace(/\s+/g, ' ').trim();
    if (!t) { var im = el.querySelector && el.querySelector('img[alt]'); if (im) t = im.getAttribute('alt') || ''; }
    return t.slice(0, 80);
  }
  function classify(el) {
    var g = '';
    if (el.closest('.mega-menu__promo')) return ['nav_mega', 'promo'];
    var mm = el.closest('.mega-menu');
    if (mm) {
      var li = el.closest('.mega-menu__linklist > li');
      var head = li && li.querySelector(':scope > a.h6');
      g = head && head !== el ? txt(head) : (head === el ? 'heading' : '');
      return ['nav_mega', g];
    }
    if (el.closest('.hc-drill')) {
      var panel = el.closest('.hc-drill__panel');
      return ['nav_drawer', panel ? (panel.getAttribute('data-panel') || '') : ''];
    }
    if (el.closest('.hc-secondary-nav, [data-hc-secondary-nav]')) return ['nav_secondary', ''];
    if (el.closest('header, .header')) return ['header', ''];
    if (el.closest('footer, .footer')) return ['footer', ''];
    if (el.closest('.product-card, product-card, .product-variant, [data-product-card]')) return ['product_card', ''];
    if (el.closest('form[action*="/cart/add"], product-form, .product-form')) return ['pdp_buy', ''];
    if (el.closest('shopify-chat, [id*="chat"]')) return ['chat', ''];
    if (el.closest('.hc-fit-finder, [class*="fit-finder"], [id*="fit-finder"]')) return ['fit_finder', ''];
    if (el.closest('.shopify-section')) return ['section', ''];
    return ['page', ''];
  }
  function section(el) {
    var s = el.closest('.shopify-section');
    return s ? (s.id || '').replace(/^shopify-section-/, '').slice(0, 60) : '';
  }
  function send(name, p) {
    if (window.__xwTrackSink) { window.__xwTrackSink.push({ name: name, p: p }); }
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, p);
      else if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, p));
    } catch (e) {}
  }
  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var el = t.closest('a, button, [role="button"], summary, input[type="submit"], label[for]');
    if (!el) return;
    var c = classify(el), label = txt(el);
    var href = el.getAttribute('href') || '';
    var target = href ? href.replace(/^https?:\/\/(www\.)?xenaworkwear\.com/, '').slice(0, 100) : (el.name || el.id || '').slice(0, 60);
    var key = c[0] + '|' + label + '|' + target;
    var now = Date.now();
    if (last.k === key && now - last.t < 400) return;
    last = { k: key, t: now };
    var de = document.documentElement;
    var w = Math.max(de.clientWidth, 1);
    var p = {
      xw_area: c[0], xw_group: c[1], xw_label: label, xw_target: target,
      xw_section: section(el), xw_page_type: pageType(),
      xw_device: w < 750 ? 'mobile' : (w < 1100 ? 'tablet' : 'desktop'),
      xw_x_pct: Math.round((e.clientX / w) * 100), xw_y_px: Math.round(e.pageY || 0)
    };
    send('xw_click', p);
    if (c[0] === 'nav_mega' || c[0] === 'nav_drawer' || c[0] === 'nav_secondary' || c[0] === 'header' || c[0] === 'footer') send('xw_nav_click', p);
  }
  document.addEventListener('click', onClick, { capture: true, passive: true });
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open || !d.closest('header, .header')) return;
    var s = d.querySelector('summary');
    send('xw_menu_open', { xw_area: 'header', xw_label: s ? txt(s) : '', xw_page_type: pageType() });
  }, true);
})();